// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"0ff7eaff","732":"80a6c25e","977":"adfe8751"}[chunkId] + ".chunk.js";
};